import { IAccess } from "@gtmhub/sessions";
import { IUser } from "@gtmhub/users";

export function allowedActionsSync(user: IUser, accessObject: IAccess): string[] {
  const allowedActions = [];
  const accessIds = [];
  // build access principals
  for (let i = 0; i < accessObject.permissions.length; i++) {
    accessIds[accessObject.permissions[i].principalId] = accessObject.permissions[i].grant.general;
  }

  const userPrincipalIds = [];
  // first putting the user himself
  userPrincipalIds.push(user.id);

  // then the account
  userPrincipalIds.push(user.accountId);

  for (let i = 0; i < user.roles.length; i++) {
    userPrincipalIds.push(user.roles[i].id);
  }

  for (let i = 0; i < userPrincipalIds.length; i++) {
    if (accessIds[userPrincipalIds[i]]) {
      for (let s = 0; s < accessIds[userPrincipalIds[i]].length; s++) {
        if (allowedActions.indexOf(accessIds[userPrincipalIds[i]][s]) === -1) {
          allowedActions.push(accessIds[userPrincipalIds[i]][s]);
        }
      }
    }
  }
  return allowedActions;
}
